<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-6 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

        <!--==========Class dropdown============-->
      <div class="col-md-2">
        <!-- <select class="form-control " id="class-dropdown" v-model="selectedSection"
         @change="callFilterModel()">
          <option v-for="classs in Users" :key=classs.classId :value="classs.sectionId">
            {{classs.fullName}}
          </option>
        </select> -->
      </div>

        <!---SEARCH BOX-->
         <div class="col-md-3">
          <div class="searchbox input-group" role="group">
          <input class="form-control search-box my-search-box" type="text" placeholder="Username or Company" aria-label="search" v-model="filteredText">
         
          <button class="search-button btn btn-primary filter"  @click="getUsers()"><i class="fa fa-search search-icon"></i></button>
          </div>
          
        </div>
        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddUserModal>Add </div>
            </div>
          </a>
        </div> 
       </div>
       <div class="row"><div class="col"><hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;"></div></div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
             
                <th role="columnheader" style="width: 8%">User Name</th>
                <th role="columnheader" style="width: 20%">Full Name</th>
                <th role="columnheader" style="width: 15%">Company</th>
                <th role="columnheader" style="width: 10%">Email</th>
                <th role="columnheader" style="width: 10%">Phone</th>
                <th role="columnheader" style ="width:10%">Role </th>
                <th role="columnheader" style ="width:10%">Action </th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "Users===null" >
                <td colspan="7"></td>
              </tr>
              
              

            <tr v-else v-for="user in Users" :key=user.id>
              <td  role="cell" style="text-decoration: underline;">
                <router-link :to="{ name: 'users', params: { user } }">
                      {{user.userName}}
                </router-link>
              </td>
              <td  role="cell">{{user.firstName}} {{user.lastName}}</td>
             
              <td  role="cell">{{user.companyName}}</td>
              <td  role="cell">{{user.email}}</td>
              <td  role="cell">{{user.phoneNumber}}</td>
              <td  role="cell">{{user.role}}</td>
              <td>
                <span @click= "passRecordToEdit(user)">
                  <i role="button" style="color:green" class="far fa-edit"></i>&nbsp;|&nbsp;
                </span>
                <span @click= "passRecordToDelete(user.id)">
                  <i role="button" style="color:green" class="far fa-trash-alt"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getUsers()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
          <b-pagination
            v-model= "page"
            :total-rows= rows
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            @change="getPage"
          ></b-pagination>
         
        </div>
      </div>
       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
      <AddUserModal/>
    <DeleteUserModal :userId = "userToDelete"/>
    <b-modal style="padding:15px" size="lg" id="EditUserModal" ref="modal" title="Edit User" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditUserForm != undefined ? !this.$refs.EditUserForm.checkValidity() : true">
        <form ref="EditUserForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-4">
              <!--NAME INPUT-->
              <b-form-group :state="userNameState" label="User Name" label-for="username-input" :invalid-feedback="usernameInvalidFeedback" autocomplete="off">
                <b-form-input id="username-input" v-model= "UserName" :state="userNameState" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
               <b-form-group  label="First Name" label-for="firstName-input" autocomplete="off">
                <b-form-input id="firstName-input" v-model= "FirstName"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group  label="Last Name" label-for="lastName-input" autocomplete="off">
                <b-form-input id="lastName-input" v-model= "LastName"  required></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
               <b-form-group :state="emailState" label="Email" label-for="email-input" :invalid-feedback="emailInvalidFeedback" autocomplete="off">
                <b-form-input id="email-input" v-model= "Email" :state="emailState" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
               <b-form-group :state="passwordState" label="Password" label-for="password-input" :invalid-feedback="passwordInvalidFeedback" autocomplete="off">
                <b-form-input id="password-input" v-model= "Password" :state="passwordState" required></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class = "row">
            <div class="col-md-6">
              <b-form-group :state="phoneNumberState" label="Phone" label-for="phone-input" :invalid-feedback="phoneInvalidFeedback" autocomplete="off">
                <b-form-input id="phone-input" v-model= "PhoneNumber" :state="phoneNumberState" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group :state="roleState" label="Role" label-for="role-input" autocomplete="off">
                <!-- <b-form-input id="role-input" v-model= "Role" :state="roleState" required></b-form-input> -->
                <b-form-select id="role-input" v-model= "Role" :options="roles" value-field = "id"  text-field = "name" required></b-form-select>
              </b-form-group>
            </div>
          </div>
           
        </form>
      </b-modal>
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddUserModal from '../../modals/AddUserModal'
import DeleteUserModal from '../../modals/DeleteUserModal'
export default {
    name: 'Users',
    mounted()
    {
      console.log(this.$auth.user());
    },
    data(){
        return{
          moduleName:'Users',
          Id:null,
          UserName:'',
          FirstName:'',
          LastName:'',
          Email:'',
          Password:'',
          PhoneNumber:'',
          Role:null,
          Company:null,
          roles: [],       
          userToEdit :  null,
          userToDelete:null,
          Users:[''],
          isLoading:true,

          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25
         
		}
  },
 computed:{
   
    userNameState()
    {   
     return this.UserName.length >= 4
    },
    usernameInvalidFeedback(){
      return 'username must contains 4 or more characters';
      },
    emailState()
    {
      const re = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
      return re.test(String(this.Email).toLowerCase());
    },
    emailInvalidFeedback()
    {
      return 'invalid email address';
    },
    passwordState()
    {
      return this.Password.length >=5;
    },
    passwordInvalidFeedback()
    {
      return 'password should contains 5 or more characters'
    },
    
    phoneNumberState()
    {
      const re  = /^[\d]{11}$/;
      return re.test(this.PhoneNumber);
      
    },
    phoneInvalidFeedback()
    {
      return 'phone number should be 11 digits long';
    },
    roleState()
    {
      return this.Role >=1 && this.Role <=3
    },
    roleInvalidFeedback()
    {
      return 'please select a role'
    }
        
  },
methods:{
  getPage(page)
  {
    this.page = page;
    this.getUsers();
  },
   editUser(){ 
        console.log(this.UserName)
     axios.post('/user/Edit', 
      {"Id":this.Id, "UserName":this.UserName,"FirstName":this.FirstName, "LastName":this.LastName, "Email":this.Email,
      "Password":this.Password,"PhoneNumber":this.PhoneNumber,"Role":this.Role,"CompanyId":this.$auth.user().companyId
      })
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('User has been edited successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go()
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
   checkFormValidity() {
        const valid = this.$refs.EditUserForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.UserName='';
        this.FirstName = '';
        this.LastName = '';
        this.Email = '';
        this.Password = '';
        this.PhoneNumber = '',
        this.Role =''
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.editUser()
       
        this.$nextTick(() => {
          //this.$router.go('/phones')
          this.$bvModal.hide('EditUserModal')
        
        })
      },
      getCompanyRoles()
    {
     
      axios.post('/role/getall', 
      {"CompanyId":this.Company})
      .then(res=>{
            if(res.data.status == 1)
            {
              this.roles = res.data.data;
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },
   updateModal()
  {
    
     
        this.UserName= this.userToEdit.userName;
        this.Id = this.userToEdit.id;
        this.FirstName = this.userToEdit.firstName;
        this.LastName = this.userToEdit.lastName;
        this.Email = this.userToEdit.email;
        this.Password = this.userToEdit.password;
        this.PhoneNumber = this.userToEdit.phoneNumber;
        this.Role =this.userToEdit.roleId;
        this.Company = this.userToEdit.companyId
        this.getCompanyRoles();
        
    },
  passRecordToDelete(id)
  {
    this.userToDelete = id;
    this.$bvModal.show('DeleteUserModal')

  },
  passRecordToEdit(user)
  {
    this.userToEdit = user;
   
    this.$bvModal.show('EditUserModal')
    
   
  },
    getUsers(){
    
      this.isLoading = true;
      axios.post('/user/getall',{"PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      console.log(res.data)
      this.isLoading = false;
      this.Users=res.data.data;

      this.rows = res.data.totalRecords
     
    });
  },
	
   


  search(){
   
    this.page=this.pageNumOnSearch;
    this.getUsers();
  }
  },
	created(){
    this.getUsers();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    AddUserModal,
    DeleteUserModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}

.col{
  padding-left:0px;
  padding-right:0px;
}

</style>